import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
var PublicPrivateToggle = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.variant, variant = _b === void 0 ? 'inherit' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.firstLabel, firstLabel = _d === void 0 ? 'Public' : _d, _e = _a.secondLabel, secondLabel = _e === void 0 ? 'Private' : _e;
    var theme = useTheme();
    var sizeConfig = {
        small: {
            height: 30,
            padding: '0px 8px',
            fontSize: 13
        },
        medium: {
            height: 36,
            padding: '0px 12px',
            fontSize: 14
        },
        large: {
            height: 48,
            padding: '0px 16px',
            fontSize: 15
        }
    };
    var config = sizeConfig[size];
    var getSelectedBackgroundColor = function () {
        if (variant === 'primary') {
            return theme.palette.primary.main;
        }
        return theme.palette.grey[800];
    };
    var getSelectedColor = function () {
        return theme.palette.common.white;
    };
    return (_jsxs(ToggleButtonGroup, { value: value, exclusive: true, onChange: function (_event, newValue) {
            if (newValue !== null) {
                onChange(newValue);
            }
        }, sx: {
            display: 'flex',
            width: '100%',
            backgroundColor: size === 'large' ? alpha(theme.palette.grey[500], 0.08) : undefined,
            '& .MuiToggleButton-root': {
                flex: 1,
                height: config.height,
                padding: config.padding,
                fontSize: config.fontSize,
                fontWeight: 700,
                color: variant === 'primary' ? theme.palette.primary.dark : theme.palette.text.primary,
                border: 'none',
                '&.Mui-selected': {
                    backgroundColor: getSelectedBackgroundColor(),
                    color: getSelectedColor(),
                    '&:hover': {
                        backgroundColor: getSelectedBackgroundColor()
                    }
                }
            }
        }, children: [_jsx(ToggleButton, { value: 'Public', sx: { borderRadius: '8px 0px 0px 8px' }, children: firstLabel }), _jsx(ToggleButton, { value: 'Private', sx: { borderRadius: '0px 8px 8px 0px' }, children: secondLabel })] }));
};
export default PublicPrivateToggle;
